import { Building2, Users, FileCheck, Clock, HeadphonesIcon } from "lucide-react";

const WhyChooseSection = () => {
  const features = [
    {
      icon: Building2,
      title: "Locally Owned Cleaning Company",
      description:
        "We're proud to be a Houston-based business, serving our local community with dedication.",
    },
    {
      icon: Users,
      title: "Experienced Cleaning Team",
      description:
        "Our professionally trained staff brings expertise and attention to detail to every job.",
    },
    {
      icon: FileCheck,
      title: "Transparent Estimates",
      description:
        "No hidden fees or surprises. We provide clear, upfront pricing for all our services.",
    },
    {
      icon: Clock,
      title: "Reliable Scheduling",
      description:
        "Count on us to arrive on time and complete your cleaning within the scheduled window.",
    },
    {
      icon: HeadphonesIcon,
      title: "Friendly Customer Support",
      description:
        "Our team is here to answer your questions and ensure your complete satisfaction.",
    },
  ];

  return (
    <section
      id="why-choose"
      className="section-padding bg-section-blue"
      data-testid="why-choose-section"
    >
      <div className="container-custom">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-16 items-center">
          {/* Image Column */}
          <div className="order-2 lg:order-1">
            <div className="grid grid-cols-2 gap-4">
              <img
                src="https://images.unsplash.com/photo-1664008760004-182420e58e7c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMjh8MHwxfHNlYXJjaHwyfHxwcm9mZXNzaW9uYWwlMjBob3VzZSUyMGNsZWFuaW5nJTIwc2VydmljZXxlbnwwfHx8fDE3NzI3MjcxOTZ8MA&ixlib=rb-4.1.0&q=85"
                alt="Professional cleaning"
                className="rounded-2xl shadow-lg w-full h-64 object-cover"
                data-testid="why-choose-image-1"
              />
              <img
                src="https://images.unsplash.com/photo-1597406462800-280ba190eb4c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMjd8MHwxfHNlYXJjaHwzfHxjbGVhbiUyMG1vZGVybiUyMGxpdmluZyUyMHJvb20lMjBpbnRlcmlvciUyMGJyaWdodHxlbnwwfHx8fDE3NzI3MjcxOTV8MA&ixlib=rb-4.1.0&q=85"
                alt="Clean living room"
                className="rounded-2xl shadow-lg w-full h-64 object-cover mt-8"
                data-testid="why-choose-image-2"
              />
              <img
                src="https://images.unsplash.com/photo-1567767326925-e2047bf469d0?q=80&w=1740&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D"
                alt="Clean kitchen"
                className="rounded-2xl shadow-lg w-full h-64 object-cover -mt-8"
                data-testid="why-choose-image-3"
              />
              <img
                src="https://images.unsplash.com/photo-1701651545983-c3b357a8387f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMjh8MHwxfHNlYXJjaHw0fHxwcm9mZXNzaW9uYWwlMjBob3VzZSUyMGNsZWFuaW5nJTIwc2VydmljZXxlbnwwfHx8fDE3NzI3MjcxOTZ8MA&ixlib=rb-4.1.0&q=85"
                alt="Vacuum cleaning"
                className="rounded-2xl shadow-lg w-full h-64 object-cover"
                data-testid="why-choose-image-4"
              />
            </div>
          </div>

          {/* Content Column */}
          <div className="order-1 lg:order-2">
            <span className="inline-block px-4 py-2 bg-sky-100 text-sky-700 rounded-full text-sm font-medium mb-4">
              Why Choose Us
            </span>
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-slate-900 mb-6">
              Why Choose Our Cleaning Service
            </h2>
            <p className="text-lg text-slate-600 mb-10">
              We're committed to providing exceptional cleaning services that exceed 
              your expectations. Here's what sets us apart:
            </p>

            {/* Features List */}
            <div className="space-y-6" data-testid="features-list">
              {features.map((feature, index) => (
                <div
                  key={index}
                  className="feature-item bg-white rounded-xl shadow-sm hover:shadow-md transition-shadow"
                  data-testid={`feature-${index}`}
                >
                  <div className="feature-icon">
                    <feature.icon className="w-5 h-5" />
                  </div>
                  <div>
                    <h4 className="font-semibold text-slate-900 mb-1">
                      {feature.title}
                    </h4>
                    <p className="text-slate-600 text-sm">
                      {feature.description}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhyChooseSection;
